import {
  GET_CARDS_DATA,
  GET_CARD_RECIPIENT_DATA,
  GET_UPDATE_CARD_RECIPIENT_DATA,
  GET_SEARCH_ZIPCODE_DATA,
} from 'store/constants'

export function getCards(values) {
  return {
    type: GET_CARDS_DATA,
    payload: values,
  }
}

export function getCardRecipient(values) {
  return {
    type: GET_CARD_RECIPIENT_DATA,
    payload: values,
  }
}

export function updateCardRecipient(values) {
  return {
    type: GET_UPDATE_CARD_RECIPIENT_DATA,
    payload: values,
  }
}

export function searchZipCode(values) {
  return {
    type: GET_SEARCH_ZIPCODE_DATA,
    payload: values,
  }
}
